import { render, staticRenderFns } from "./McGeoughsLetterhead.vue?vue&type=template&id=7318a568&scoped=true&"
import script from "./McGeoughsLetterhead.vue?vue&type=script&lang=js&"
export * from "./McGeoughsLetterhead.vue?vue&type=script&lang=js&"
import style0 from "./McGeoughsLetterhead.vue?vue&type=style&index=0&id=7318a568&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7318a568",
  null
  
)

export default component.exports